import LegalbirdIoModal from "../../Modal/LegalbirdIoModal";
import ButtonLoading from "../../Button/ButtonLoading";
import React, { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import Typography from "@mui/material/Typography";
import LegalbirdTipTapEditorProvider from "../../LbEditor/LegalbirdTipTapEditorProvider";
import LegalbirdTipTapEditor from "../../LbEditor/LegalbirdTipTapEditor";
import { useCurrentEditor } from "@tiptap/react";
import { getEditorHtml } from "../../../services/Editor/editorFunctions";
import { ProductUnion } from "../../../types/ProductUnion";
import { useMutation } from "@tanstack/react-query";
import { createResource } from "../../../services/ReactQuery/reactQueryService";
import dayjs from "dayjs";

type CreateActivityNoteModalProps = {
  product: ProductUnion;
  open: boolean;
  closeDialog: Function;
  updateActivities: Function;
};

export default function CreateActivityNoteModal(props: CreateActivityNoteModalProps) {
  return (
    <LegalbirdTipTapEditorProvider>
      <CreateActivityNoteModalInner {...props} />
    </LegalbirdTipTapEditorProvider>
  );
}

function CreateActivityNoteModalInner({ open, closeDialog, product, updateActivities }: CreateActivityNoteModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { editor } = useCurrentEditor();
  const createMutation = useMutation({
    mutationFn: createResource
  });

  useEffect(() => {
    editor?.commands.setContent(initialContent);
  }, []);

  const onSubmit = async () => {
    setIsLoading(true);
    const backofficeCase = product.backofficeCase;

    try {
      await createMutation.mutateAsync({
        uri: "activities",
        data: {
          subject: "Externer Kundenberater Gesprächsnotiz",
          dueDate: dayjs(),
          dueTime: dayjs().format("HH:mm"),
          assignedUser: backofficeCase.accountManager?.["@id"] ?? null,
          mandatory: true,
          type: "call_notes",
          note: getEditorHtml(editor, true),
          duration: 3,
          case: backofficeCase["@id"],
          useActivityScheduling: true,
        },
      });

      enqueueSnackbar("Gesprächsnotiz wurde für zuständigen Mitarbeiter gesetzt", {
        variant: "custom",
        isNonInteractive: true,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
      });
    } catch (e) {
      enqueueSnackbar("Es ist ein technischer Fehler aufgetreten, bitte versuchen Sie es erneut", {
        variant: "custom",
        isNonInteractive: true,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "center",
        },
      });
    }
    await updateActivities();

    setIsLoading(false);
    handleClose();
  };

  const handleClose = () => {
    editor?.commands.setContent(initialContent);
    closeDialog();
  };

  return (
    <LegalbirdIoModal
      handleClose={handleClose}
      open={open}
      title={"Gesprächsnotiz erstellen"}
      submitButton={
        <ButtonLoading
          onClick={onSubmit}
          color="primary"
          variant={"contained"}
          isLoading={isLoading}
          disabled={!editor || editor.isEmpty}
        >
          Speichern
        </ButtonLoading>
      }
    >
      <Typography sx={{ color: "red" }} align={"center"}>
        Achtung: Bitte <strong>nicht</strong> für reine Fallbeschreibungen nutzen, sondern nur{" "}
        <strong>konkrete To-Dos</strong> für Legalbird eintragen!
      </Typography>

      <br />
      <LegalbirdTipTapEditor />
    </LegalbirdIoModal>
  );
}

const initialContent =
  "<p><strong>Anrufer (bitte ankreuzen):</strong> Mandantschaft ( ) / Gegenseite ( ) / Gericht ( ) / Sonstiger Anrufer ( )</p>" +
  "<p><strong>Name des Anrufers:</strong></p>" +
  "<p><strong>Telefonnummer:</strong></p>" +
  "<p><strong>Anliegen:</strong></p>";
